import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import style from './SubtitleSimilar.module.scss'
import { selectMovie } from '../../../../../redux/movieSlices/MovieSelector'

let SubtitleSimilar = () => {

    const { similar } = useSelector(selectMovie)

    return (
        <div className={style.subtitle__similar}>
            <span>Similar movies</span>
            <div className={style.similar}>
                <div className={style.container__similar}>
                    <a href={similar[3].url}>
                        <img className={style.similar__img} src={similar[0].medium_cover_image} />
                        <span className={style.similar__text} >{similar[0].title_long}</span></a>
                </div>
                <div className={style.container__similar}>
                    <a href={similar[3].url}>
                        <img className={style.similar__img} src={similar[1].medium_cover_image} />
                        <span className={style.similar__text}  >{similar[1].title_long}</span></a>
                </div>
                <div className={style.container__similar}>
                    <a href={similar[3].url}>
                        <img className={style.similar__img} src={similar[2].medium_cover_image} />
                        <span className={style.similar__text}  >{similar[2].title_long}</span></a>
                </div>
                <div className={style.container__similar}>
                    <a href={similar[3].url}>
                        <img className={style.similar__img} src={similar[3].medium_cover_image} />
                        <span className={style.similar__text} >{similar[3].title_long}</span></a>
                </div>
            </div>
        </div>
    )
}

export default SubtitleSimilar;